export interface PainPoint {
  title: string
  lines: string[]
}

export const painIntro: string[] = [
  'You already know how to teach riding.',
  'The problem is everything you have to prepare around every lesson.',
  'What should you work on today? Which exercise fits this rider? How should you adapt it? What comes next? How do you track progress?',
  'Then the next lesson arrives… and you start planning again.',
]

export const painClose = 'The problem isn’t your experience. It’s the time you spend preparing to teach.'

export const painPoints: PainPoint[] = [
  {
    title: '😰 TOO MUCH TIME SPENT PREPARING LESSONS',
    lines: [
      'Every rider is different.',
      'Different level. Different horse. Different confidence. Different technical needs.',
      'You know what the rider needs — but you still have to turn that into a complete lesson.',
      'Horse Riding Instructor Pro™ gives you the material already structured.',
    ],
  },
  {
    title: '⚠️ STOP SEARCHING FOR WHAT TO TEACH NEXT',
    lines: [
      'Position. Balance. Steering. Rhythm. Transitions. Coordination. Accuracy. Confidence. Pole work.',
      'You don’t need more random ideas.',
      'You need a system that helps you choose, adapt, teach, and progress faster.',
    ],
  },
  {
    title: '🐎 TURN RIDER PROBLEMS INTO BETTER LESSONS',
    lines: [
      'You notice the problem.',
      'Now you need:',
      'the right exercise, the right progression, the right arena setup, the right correction, and the right next step.',
      'Instead of creating everything yourself, use a professional system that is already prepared.',
    ],
  },
]
